import { TrashIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

import { Button } from '../Button';

interface RemoveButtonProps {
  onClick: () => void;
  disabled?: boolean;
  hasError?: boolean;
  variant?: RemoveButtonVariant;
  className?: string;
  iconSize?: 'sm' | 'md';
}

export enum RemoveButtonVariant {
  DEFAULT = 'default',
  FORM_FIELD = 'form-field',
  SECTION = 'section',
}

export const RemoveButton = ({
  onClick,
  disabled = false,
  hasError = false,
  variant = RemoveButtonVariant.DEFAULT,
  className,
  iconSize = 'md',
}: RemoveButtonProps) => {
  const baseClasses =
    'inline-flex rounded-full bg-white text-gray-500 hover:bg-gray-50';

  const variantClasses = {
    [RemoveButtonVariant.DEFAULT]: 'p-4',
    [RemoveButtonVariant.FORM_FIELD]: clsx(
      'p-4 ml-2 mt-3',
      hasError ? 'mb-6' : 'mb-0',
    ),
    [RemoveButtonVariant.SECTION]: clsx(
      'p-4 mt-8 -ml-3',
      hasError ? 'mb-4' : 'mb-0',
    ),
  };

  const disabledClasses = disabled
    ? 'disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white'
    : '';

  const iconClasses = iconSize === 'sm' ? 'h-4 w-4' : 'h-6 w-6';

  return (
    <Button
      disabled={disabled}
      type="button"
      className={clsx(
        baseClasses,
        variantClasses[variant],
        disabledClasses,
        className,
      )}
      onClick={onClick}
    >
      <TrashIcon className={iconClasses} />
    </Button>
  );
};
